module.exports = __webpack_public_path__ + "static/media/IN.70a367ac.png";